import React from 'react'
import { PRESCRIPTION_COLORS_MAP } from '../../../inputComponents/common/color-utils'
import { PMPBodySectionItems } from './styledComponent'
import {
  getCasedHeadingTextBasedOnStyleOverrides,
  prepareFinalRequestedTestsSentence,
} from './util'

export default function PrintableInvestigations({
  investigationsRef,
  debug,
  selectedInvestigations,
  finalRequestedTestsBy,
  debugHighlightStates,
  styleOverrides,
}) {
  const finalRequestedTestSentence = prepareFinalRequestedTestsSentence(finalRequestedTestsBy)

  return (
    <PMPBodySectionItems
      ref={investigationsRef}
      debug={debug}
      debugColor={PRESCRIPTION_COLORS_MAP.investigations.color}
      debugHighlight={debugHighlightStates?.investigations}
      investigations
      borderLeft={styleOverrides?.borderLeft}
      paddingLeft={styleOverrides?.paddingLeft}
    >
      <span
        style={{
          fontSize: styleOverrides?.headingFontSize
            ? `${styleOverrides?.headingFontSize}px`
            : 'inherit',
          color: styleOverrides?.headingColor || styleOverrides?.color || 'inherit',
          fontWeight: 600,
        }}
      >
        <strong>
          {getCasedHeadingTextBasedOnStyleOverrides({
            headingText: `Investigations Needed ${
              finalRequestedTestSentence ? `(${finalRequestedTestSentence})` : ''
            }`,
            styleOverrides,
          })}
        </strong>
      </span>
      <div
        style={{
          fontSize: styleOverrides?.fontSizePixels
            ? `${styleOverrides?.fontSizePixels}px`
            : 'inherit',
          color: styleOverrides?.color || styleOverrides?.headingColor || 'inherit',
        }}
      >
        {selectedInvestigations?.map((item) => item?.label)?.join(', ')}
      </div>
    </PMPBodySectionItems>
  )
}
